<template>
    <input :type='fieldType'
           placeholder="Empty"
           ref="input"
           class="form-control"
           :class="{ 'is-invalid': error }"
           :name="name"
           :value="value"
           :required="required"
           :disabled="disabled"
           @input="handleInput($event.target.value)"
    />
</template>

<script>
    const EVENTS = {
        INPUT: 'input',
    }

    export default {
        name: 'text-input',
        props: {
            error: String,
            name: {type: String, required: true},
            value: {},
            required: {type: Boolean, default: false},
            disabled: {type: Boolean, default: false},
            validChars: {type: Array},
            validation: {type: String, required: true},
        },
        methods: {
            handleInput,
            validate,
        },
        computed: {
            fieldType: function() {
                if (this.validation === 'date') {
                    return 'date';
                }
                return 'text';
            },
        }
    };

    function validate(value) {
        if (!this.validChars || !value) return value;
        let result = '';
        value.split('').forEach(char => {
            if (this.validChars.includes(char)) result += char;
        });
        return result;
    }

    function handleInput(value) {
        const validatedValue = this.validate(value);
        this.$refs.input.value = validatedValue;
        this.$emit(EVENTS.INPUT, validatedValue);
    }

</script>
